<template>
	<div class="p-3">
		<sub-goal-settings-content />
	</div>
</template>

<script>
import SubGoalSettingsContent from '@/components/Widget/SubGoalSettingsContent.vue';

export default {
	components: { SubGoalSettingsContent },
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
		}
	},
};
</script>

<style>
html, body, #app {
	margin: 0;
	padding: 0;
}
</style>
